import { httpsCallable } from 'firebase/functions';
import { functions } from '../../lib/firebase';
import { currentUiLanguage } from '../../i18n';

export const EMAIL_VERIFICATION_SENT_EVENT = 'notreu:email-verification-sent';

export type ServerPhase = 'verified' | 'exempt' | 'A' | 'B' | 'C';

export interface EmailVerificationStatus {
  serverNowMs: number;
  phase: ServerPhase;
  emailVerified: boolean;
  applicable: boolean;
  creationMs: number;
  lockAtMs: number;
  noticeAcked: boolean;
  pendingEmail: string | null;
  /** 登録時のシリーズ。不明なら null（公開RAGの案内を出す側に倒す） */
  series?: 'ncn' | 'ncg' | null;
}

export async function fetchEmailVerificationStatus(): Promise<EmailVerificationStatus> {
  const res = await httpsCallable(functions, 'getEmailVerificationStatusFn')({});
  return res.data as EmailVerificationStatus;
}

/** series は登録直後の送信でだけ渡す（再送ではサーバー保存済みの値が使われる） */
export async function sendVerificationEmail(
  series?: 'ncn' | 'ncg'
): Promise<{ status: 'sent' | 'already_verified'; email?: string }> {
  const res = await httpsCallable(functions, 'sendVerificationEmailFn')({
    lang: currentUiLanguage(),
    ...(series ? { series } : {}),
  });
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(EMAIL_VERIFICATION_SENT_EVENT));
  return res.data as { status: 'sent' | 'already_verified'; email?: string };
}

export async function requestEmailChange(newEmail: string): Promise<{ status: 'sent'; newEmail: string }> {
  const res = await httpsCallable(functions, 'requestEmailChangeFn')({ newEmail, lang: currentUiLanguage() });
  return res.data as { status: 'sent'; newEmail: string };
}

export async function syncEmailVerification(): Promise<{ emailVerified: boolean; email: string | null }> {
  const res = await httpsCallable(functions, 'syncEmailVerificationFn')({});
  return res.data as { emailVerified: boolean; email: string | null };
}

export async function acknowledgeEmailNotice(): Promise<void> {
  await httpsCallable(functions, 'acknowledgeEmailNoticeFn')({});
}

/** Callable のエラーから details.code / retryAfterSec を取り出す */
export function readCallableError(e: unknown): { code: string; retryAfterSec?: number; message: string } {
  const err = e as { code?: string; message?: string; details?: { code?: string; retryAfterSec?: number } };
  return {
    code: err?.details?.code || err?.code || 'unknown',
    retryAfterSec: err?.details?.retryAfterSec,
    message: err?.message || '',
  };
}
